import { Component, OnInit } from '@angular/core';
import { AiUploadBatchObjectsService } from '../../../services/ai-upload-batch-objects.service';
import { ToastrService } from 'ngx-toastr';
import { AiUploadBatchObjectCounts } from '../../../models/ai-upload-batch-object.model';
import { AiUploadHistoryService } from '../../../services/ai-upload-history.service';

@Component({
  selector: 'lib-ai-overview',
  templateUrl: './ai-overview.component.html',
  styleUrls: ['./ai-overview.component.scss'],
  standalone: false
})
export class AiOverviewComponent implements OnInit {
  
  constructor(
    private aiUploadBatchObjectsService: AiUploadBatchObjectsService,
    private toastr: ToastrService,
    private aiUploadHistoryService: AiUploadHistoryService
  ){}
  aiUploadBatchObject!: AiUploadBatchObjectCounts;
  totalSegmentedObjects: number = 0;
  feedersCount: number = 0;
  totalBatchImageSets: number = 0;

   ngOnInit(): void {
    this.getAnalytics();
    this.getFeedersCount();
    this.getTotalBatchImageSets();
   }

   private getAnalytics() {
    this.aiUploadBatchObjectsService.getSegmentationData().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.aiUploadBatchObject = new AiUploadBatchObjectCounts(responseData.data.categoryCounts);
          this.getTotalSegmentedObjectCount();
          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch segmentation data');
        }
      },
      error: (error) => {
        this.toastr.error('An error occurred while fetching segmentation data');
      }
    });
  }

  private getFeedersCount(){
    this.aiUploadHistoryService.getFeedersCount().subscribe
    ({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.feedersCount = responseData.data;
          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch feeders count');
        }
      },
      error: (error) => {
        this.toastr.error('An error occurred while fetching feeders count');
      }
    });
  }

  private getTotalBatchImageSets(){
    this.aiUploadHistoryService.getTotalBatchImageSets().subscribe
    ({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.totalBatchImageSets = responseData.data;
          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch total batch image sets');
        }
      },
      error: (error) => {
        this.toastr.error('An error occurred while fetching total batch image sets');
      }
    });
  }

  private getTotalSegmentedObjectCount() {
    if (this.aiUploadBatchObject) {
      this.aiUploadBatchObject.totalSegmentedObjectsCount = 
        this.aiUploadBatchObject.buildingsCount +
        this.aiUploadBatchObject.lvPolesCount +
        this.aiUploadBatchObject.dtPoleMountedCount +
        this.aiUploadBatchObject.dtGroundMountedCount +
        this.aiUploadBatchObject.mvPolesCount +
        this.aiUploadBatchObject.injectionSubstations +
        this.aiUploadBatchObject.hvPolesCount +
        this.aiUploadBatchObject.tsCount;
    }
  }
}
